import { useContext } from 'react'

import { SchoolContext } from '../../../Providers/SchoolProvider'
import SearchList from '../../antd/Lists/SearchList'
import EntityBadge, { getEntityRank } from '../Badges/EntityBadge'

const InstitutionsList = ({ bordered, selected, maxHeight, onSelectedChange }) => {
  const { unmanagedInstitutions } = useContext(SchoolContext)

  const institutionOptions = [...unmanagedInstitutions]
    .sort((a, b) => {
      const rankDiff = getEntityRank(a) - getEntityRank(b)

      if (rankDiff !== 0) {
        return rankDiff
      }

      return (a.name ?? '').localeCompare(b.name ?? '')
    })
    .map(institution => ({
      label: (
        <span className='flex-row ai-ctr' style={{ gap: 5 }}>
          {institution.name}
          <EntityBadge entity={institution} size='sm' withTooltip />
        </span>
      ),
      value: institution.id,
      tooltip: institution.name
    }))

  return (
    <div className='h-100'>
      <SearchList
        selected={selected}
        data={institutionOptions}
        maxHeight={maxHeight}
        onSelectedChange={onSelectedChange}
      />
    </div>
  )
}

export default InstitutionsList
